import { LANGUAGES } from 'constants';
import moment from 'moment';

const MOBILE_SIZE = process.env.REACT_APP_MOBILE_SIZE;

export function stringToDate(dateString) {
	try {
		const [d1, d2, d3] = dateString.split('-').map(item => (parseInt(item) < 10 ? `0${parseInt(item)}` : item)); // adding leading zeros to date

		const date = `${d1}-${d2}-${d3}`; // putting the date back as it was with leading zeroes

		return moment(date, 'DD-MM-YYYY');
	} catch (error) {
		return null;
	}
}

export const saveArrayAsCSV = (fileName, objArray) => {
	const array = typeof objArray !== 'object' ? JSON.parse(objArray) : objArray;

	let str = `${Object.keys(array[0])
		.map(value => `"${value}"`)
		.join(',')}\r\n`;

	let csvContent = array.reduce((str, next) => {
		str += `${Object.values(next)
			.map(value => `"${value}"`)
			.join(',')}\r\n`;
		return str;
	}, str);

	const bom = '\uFEFF';
	csvContent = csvContent.replaceAll('<br>', '; ');
	const blob = new Blob([bom + csvContent], { type: 'text/csv;charset=utf-8,' });
	const url = URL.createObjectURL(blob);
	const link = document.createElement('a');
	link.setAttribute('href', url);
	link.setAttribute('download', `${fileName}.csv`);
	link.click();
};

export const getDateValues = date => {
	const momentDate = moment(date, 'DD-MM-YYYY hh:mm');
	const formattedDate = momentDate.format('DD-MM-YYYY');
	const hoursAndMinutes = momentDate.format('HH:mm');
	return [hoursAndMinutes, formattedDate];
};

export function totalSeconds(time) {
	//util function to calc total second of time string divided by ":" - if contain more then hour his length is 3
	const parts = time.split(':');
	if (parts.length === 2) return parts[0] * 3600 + parts[1] * 60;
	if (parts.length === 3) return parts[0] * 216000 + parts[1] * 3600 + parts[2] * 60;
}

export function capitalizeFirstLetter(string) {
	return string.charAt(0).toUpperCase() + string.slice(1);
}

export const validateMeetingValues = (startTime = null, endTime = null, meeting) => {
	const now = moment();

	// The new meeting the customer wants to schedule
	const _newStartMoment = moment(`${meeting.date}`, 'DD-MM-YYYY');
	const _newEndMoment = moment(`${meeting.date}`, 'DD-MM-YYYY');
	_newStartMoment?.set({
		hour: meeting.startTime?.split(':')[0],
		minute: meeting.startTime?.split(':')[1],
	});
	_newEndMoment?.set({
		hour: meeting.endTime?.split(':')[0],
		minute: meeting.endTime?.split(':')[1],
	});

	// Validation for the new meeting
	const _UKnewStartMoment = moment(_newStartMoment);
	_UKnewStartMoment.add(3, 'hours'); //Schedule classes up to 3 hours back from the current time.

	if (!_UKnewStartMoment?.isSameOrAfter(now)) {
		return { valid: false, message: 'Meeting date and time already Passed!', translationkey: 'validations_meeting_passed_time_error' };
	} else if (_newStartMoment.isSameOrAfter(_newEndMoment)) {
		return { valid: false, message: 'Invalid meeting hours', translationkey: 'validations_meeting_hours_error' };
	}

	if (startTime && endTime) {
		// The current meeting that already scheduled
		const _currentStartMoment = moment(`${meeting.date}`, 'DD-MM-YYYY'); // both (newMoment and currentMoment) on the same date
		const _currentEndMoment = moment(`${meeting.date}`, 'DD-MM-YYYY');
		_currentStartMoment?.set({
			hour: startTime?.split(':')[0],
			minute: startTime?.split(':')[1],
		});
		_currentEndMoment?.set({
			hour: endTime?.split(':')[0],
			minute: endTime?.split(':')[1],
		});

		// Validation that checks if the new meeting times are valid with the current meeting times
		if (_newStartMoment.isBetween(_currentStartMoment, _currentEndMoment)) {
			return {
				valid: false,
				message: `${meeting.startTime} is between another meeting`,
				translationkey: 'validations_meeting_start_time_error',
			};
		} else if (_newEndMoment.isBetween(_currentStartMoment, _currentEndMoment)) {
			return {
				valid: false,
				message: `${meeting.endTime} is between another meeting`,
				translationkey: 'validations_meeting_end_time_error',
			};
		} else if (_newStartMoment.isSame(_currentStartMoment) || _newStartMoment.isSame(_currentEndMoment)) {
			return {
				valid: false,
				message: `Meeting date at ${meeting.startTime} already taken, please change and try again`,
				translationkey: 'validations_meeting_start_time_taken_error',
			};
		} else if (_newEndMoment.isSame(_currentStartMoment) || _newEndMoment.isSame(_currentEndMoment)) {
			return {
				valid: false,
				message: `Meeting date at ${meeting.endTime} already taken, please change and try again`,
				translationkey: 'vvalidations_meeting_end_time_taken_error',
			};
		} else if (
			_currentEndMoment.isBetween(_newStartMoment, _newEndMoment) ||
			_currentStartMoment.isBetween(_newStartMoment, _newEndMoment)
		) {
			return {
				valid: false,
				message: `There is another meeting between these hours`,
				translationkey: 'validations_meeting_hours_taken_error',
			};
		}
	}

	return { valid: true, message: '' };
};

export const validateDates = (startDate, endDate) => {
	const _startDate = moment(startDate);
	const _endDate = moment(endDate);

	if (_startDate.isSameOrAfter(_endDate)) return { valid: false, message: 'Start date is same or after  end date' };
	return { valid: true, message: '' };
};

export function deepClone(obj) {
	if (obj === null || typeof obj !== 'object') {
		// If the passed in value is not an object, return the value itself
		return obj;
	}
	// Use the spread operator to create a new array or object
	// that has the same properties and values as the original
	const clone = Array.isArray(obj) ? [...obj] : { ...obj };
	// Recursively clone any nested objects or arrays
	for (const key in clone) {
		clone[key] = deepClone(clone[key]);
	}
	return clone;
}

export function findDuplicateByPropName(arrayOfObjects, propName) {
	let propCounts = {};
	let duplicateProps = [];

	arrayOfObjects.forEach(obj => {
		propCounts[obj[propName]] = (propCounts[obj[propName]] || 0) + 1;
		if (propCounts[obj[propName]] === 2) {
			duplicateProps.push(obj[propName]);
		}
	});

	return duplicateProps;
}

//converts the file to base64
const getBase64 = file => {
	return new Promise((resolve, reject) => {
		const reader = new FileReader();
		reader.onload = () => resolve(reader.result);
		reader.onerror = error => reject(error);
		reader.readAsDataURL(file);
	});
};

//_handleUploadFile
export async function prepereConversationFileToUpload(e) {
	const _file = [...e.target.files];
	if (!_file) return;
	const fileName = _file[0].name;
	const fileType = fileName.split('.').pop().toLowerCase();

	// check the file type
	const allowedTypes = ['doc', 'docx', 'pdf', 'mp3', 'jpeg', 'jpg', 'png'];
	if (!allowedTypes.includes(fileType)) {
		return { isAllowedTypes: false, fileObj: null };
	}

	const base64 = await getBase64(_file[0]);
	const _fileData = base64.split('base64,')[1];

	const fileObj = {};
	fileObj.fileData = _fileData || '';
	fileObj.fileName = fileName;
	fileObj.fileSFix = fileType;
	return { isAllowedTypes: true, fileObj };
}

export const IsMobile = window.innerWidth <= MOBILE_SIZE;

function dec2hex(dec) {
	return dec.toString(16).padStart(2, '0');
}

// generateId :: Integer -> String
export function generateId(len) {
	var arr = new Uint8Array((len || 40) / 2);
	window.crypto.getRandomValues(arr);
	return Array.from(arr, dec2hex).join('');
}

// generate  :: letters -> String
export function generateRandomName(len = 10) {
	const startAscii = 97;
	return Array(len)
		.fill('')
		.reduce(string => (string += String.fromCharCode(Math.floor(Math.random() * 25 + startAscii))));
}

//The first property is the group name (example: 'log_in').
//The second property is the translation key (example: 'log_in_title').
export const extractTranslationsBy2PropertiesAndLanguage = (generalTranslations, firstProperty, secondPropery, lang) => {
	if (!generalTranslations || !generalTranslations[firstProperty] || !generalTranslations[firstProperty][secondPropery]) return '';

	const text = generalTranslations[firstProperty][secondPropery].find(obj => obj.languageId === lang) || '';
	if (text) return text.value;

	const englishObj = LANGUAGES.find(language => language.iso === 'EN');
	return generalTranslations[firstProperty][secondPropery].find(obj => obj.languageId === englishObj.translation_id)?.value; //Return English text as default value.
};

export const isUserLanguageValid = preferredLanguageId => {
	return LANGUAGES.some(lang => lang.translation_id === preferredLanguageId);
};

// Build structured list for nested UL (UL inside UL) in the HTML Editor.
export const buildStructuredList = (listItems, nestedIndexes) => {
	const nestedSet = new Set(nestedIndexes);
	const structured = [];
	let current = null;

	listItems.forEach((item, index) => {
		const isNested = nestedSet.has(index);

		if (!isNested) {
			// New parent.
			current = { parent: item, children: [] };
			structured.push(current);
		} else if (current) {
			// Child of current parent.
			current.children.push(item);
		} else {
			// No parent before, fallback: treat as parent.
			current = { parent: item, children: [] };
			structured.push(current);
		}
	});

	return structured;
};
